import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import $ from 'jquery';

import { selectUrlData } from '../../redux/train/train.selector';

import iconBack from '../../assets/back-arrow.png';
import iconClose from '../../assets/close.png';

class FaqDetailsAccount extends React.Component {
    constructor(props) {
        super(props);
        window.jQuery = $;
        window.$ = $;
        global.jQuery = $;
    }
    myFunction(e) {
        $('.single-faq').removeClass('active');
        $(e).parent('.single-faq').addClass('active');
    }
    render() {
        const { urlData } = this.props;
        return (
            <div>
                <div className="faq-header">
                    <a href={'/ttbhelp?' + urlData}><img src={iconBack} alt="" title="" /></a>
                    <h2>Frequently Asked Questions(FAQ):</h2>
                    <Link to={'/ttbhelp/faq'}><img src={iconClose} alt="" title="" /></Link>
                </div>
                <div className="faq-content">
                    <h4>Account and Profile Management</h4>

                    <h2>What do you need help with?</h2>

                    <div className="faq-accordian">
                        <div className="single-faq active">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I create an account on RailYatri?</h3>
                            <li><strong>Download the RailYatri App:</strong> Install the app from the Google Play Store (Android) or Apple App Store (iOS).</li>
                            <li><strong>Open the App:</strong> Launch the app, and you will be prompted to either Log in or Sign up.</li>
                            <li><strong>Sign Up via Gmail:</strong> Choose the option to Sign Up and select your Gmail account to continue.</li>
                            <li><strong>Complete Your Profile:</strong> Enter any additional details, like your name, to finish setting up your account.</li>
                            <li>Once completed, your RailYatri account will be ready for use!</li>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I reset my password if I forget it?</h3>
                            <li><span >Step 1:</span> Open the RailYatri app or website.</li>
                            <li><span >Step 2:</span> Log in and go to the <em>"Trains"</em> section.</li>
                            <li><span >Step 3:</span> Enter your source and destination stations, select your journey date, and click on <em>"Search Trains."</em></li>
                            <li><span >Step 4:</span> Choose the train and class of travel (e.g., AC First Class, Sleeper) based on arrival and travel time.</li>
                            <li><span >Step 5:</span> On the passenger details page, fill in the IRCTC User ID and choose <em>"Forgot Password"</em>.</li>
                            <li><span >Step 6:</span> Enter your registered mobile number as prompted.</li>
                            <li><span >Step 7:</span> A new password will be sent to your mobile number. Copy the password and proceed with review and payment.</li>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I update my profile information?</h3>
                            <p>How to Update Your Profile on RailYatri, follow these steps:</p>

                            <li><span >Step 1:</span> Open the RailYatri app and log in.</li>
                            <li><span >Step 2:</span> Tap on the menu icon (left side) or the <em>"Your Profile"</em> icon in the bottom navigation.</li>
                            <li><span >Step 3:</span> Select <em>"Profile"</em> or <em>"My Account"</em>.</li>
                            <li><span >Step 4:</span> Update your details in the <em>"Personal Information"</em> section, such as name, email, gender, or mobile number.</li>
                            <li><span >Step 5:</span> Save the changes to confirm your updated profile information.</li>

                            <p>Your updated profile information will be saved successfully.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How can I delete my account?</h3>
                            <p>To delete your RailYatri account, follow these steps:</p>
                            <li><span>Step 1:</span> Open the RailYatri app and log in.</li>
                            <li><span>Step 2:</span> Tap on the menu icon (left side).</li>
                            <li><span>Step 3:</span> Select <em>"Delete Account"</em> and follow the prompts to confirm.</li>
                            <li><span>Step 4:</span> Click on <em>Submit</em>.</li>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What should I do if I encounter issues with my IRCTC username or password?</h3>
                            <p>You can reset your IRCTC username or password by selecting the <em>"Forgot Username"</em> or <em>"Forgot Password"</em> option on the IRCTC login screen.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I manage my travel preferences in the app?</h3>
                            <p>You can select your travel preferences like berth and meal choices while entering passenger information during the booking process.</p>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

const mapStateProps = createStructuredSelector({
    urlData: selectUrlData
})

export default connect(mapStateProps, null)(FaqDetailsAccount);
